module.exports = __webpack_public_path__ + "img/contact.562c37a4.jpg";